export default "__VITE_ASSET__2ZirKM7x__"